import { render, staticRenderFns } from "./SerialList.vue?vue&type=template&id=70ac433c"
import script from "./SerialList.vue?vue&type=script&lang=js"
export * from "./SerialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports